import { AssetType } from '@amzn/fire-tv-campaign-automation-service';

import {
  FireTVControlKey,
  FireTVPreviewState,
  PreviewConfigBase,
  PreviewControlType,
  PreviewControlValue,
  PreviewControlKey,
  PreviewGenerationStrategy,
} from '../types';

import { FIRETV_SCREEN_SAVER_STATE_CONFIGS } from './stateConfigs';

/**
 * FireTV Screen Saver Preview Configuration
 *
 * Defines preview behavior for FireTV Screen Saver placement
 *
 * States:
 * - Screen Saver: Background with logo and gradient overlay
 *
 * Behavior:
 * - Strategy: CURRENT_VARIANT - generates preview for selected variant
 * - Controls: Button group with single state option
 *
 * Canvas: 1920x1080
 */
export const FIRE_TV_SCREEN_SAVER_CONFIG: PreviewConfigBase = {
  defaultState: FireTVPreviewState.SCREEN_SAVER,
  controls: [
    {
      type: PreviewControlType.BUTTON_GROUP,
      key: FireTVControlKey.STATE,
      label: 'Preview State',
      options: [{ label: 'Screen Saver', value: FireTVPreviewState.SCREEN_SAVER }],
      defaultValue: FireTVPreviewState.SCREEN_SAVER,
    },
  ],
  behavior: {
    previewGeneration: PreviewGenerationStrategy.CURRENT_VARIANT,
    stateResolution: (values: Record<PreviewControlKey, PreviewControlValue>) => {
      return (values[FireTVControlKey.STATE] ||
        FireTVPreviewState.SCREEN_SAVER) as FireTVPreviewState;
    },
  },
  stateConfigs: FIRETV_SCREEN_SAVER_STATE_CONFIGS,
  downloads: {
    includeAssets: true,
    includePreviews: true,
    supportedAssets: [AssetType.BACKGROUND_IMAGE, AssetType.LOGO],
  },
};
